import React from 'react';
import { FaPython, FaMobileAlt, FaDatabase, FaLock, FaBoxes } from 'react-icons/fa';
import { SiFlutter, SiDart, SiFastapi, SiFirebase, SiGit, SiGooglegemini } from 'react-icons/si';

const skills = [
    { icon: <SiFlutter />, name: 'Flutter', detail: 'Cross-platform mobile apps with clean UI and responsive layouts.' },
    { icon: <SiDart />, name: 'Dart', detail: 'Type-safe app logic, reactive programming, and modular structure.' },
    { icon: <FaBoxes />, name: 'Provider', detail: 'State management for scalable, efficient, and reactive UI flows.' },
    { icon: <FaDatabase />, name: 'MVVM Architecture', detail: 'Structured separation of concerns for clean and maintainable codebases.' },
    { icon: <SiFastapi />, name: 'FastAPI', detail: 'High-performance RESTful APIs and asynchronous backend routing.' },
    { icon: <FaPython />, name: 'Python', detail: 'Backend service logic, script automation, and AI prompt engineering.' },
    { icon: <SiFirebase />, name: 'Firebase', detail: 'Authentication, real-time Firestore synchronization, and cloud backend.' },
    { icon: <SiGooglegemini />, name: 'AI Integration', detail: 'Integrating AI capabilities, prompt engineering, and smart content flows.' },
    { icon: <FaLock />, name: 'REST APIs & JWT', detail: 'Secure HTTP endpoints, request handling, and JSON token authentication.' },
    { icon: <FaDatabase />, name: 'Database / Storage', detail: 'Offline data persistence, local indexing, and client-side caching.' },
    { icon: <SiGit />, name: 'Git & Version Control', detail: 'Codebase management, branching strategies, and team collaboration.' },
    { icon: <FaMobileAlt />, name: 'Responsive UI/UX', detail: 'Mobile-first design principles, clean layouts, and smooth user interfaces.' },
];

function Skills() {
    return (
        <div className="container">
            <div className="section-heading">
                <p className="section-title">Skills</p>
                <p className="section-subtitle">
                    A specialized engineering stack focused on cross-platform mobile development, backend APIs, and AI integrations.
                </p>
            </div>

            <div className="skills-shell">
                <div className="skills-intro-card">
                    <h3>Technical Expertise</h3>
                    <p>
                        Engineered through practical mobile application development, RESTful API architecture, and production deployment workflows.
                    </p>
                </div>

                <div className="skills-grid">
                    {skills.map((skill, index) => (
                        <div className="skill-card" key={skill.name}>
                            <div className="skill-icon">{skill.icon}</div>
                            <div className="skill-content">
                                <h5>{skill.name}</h5>
                                <p>{skill.detail}</p>
                            </div>
                            <span className="skill-index">
                                {index + 1 < 10 ? `0${index + 1}` : index + 1}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Skills;